import { render } from "./head.vue?vue&type=template&id=2d457392&scoped=true&ts=true"
import script from "./head.vue?vue&type=script&lang=ts"
export * from "./head.vue?vue&type=script&lang=ts"

import "./head.vue?vue&type=style&index=0&id=2d457392&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d457392"]])

export default __exports__